import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import View from 'ol/View.js';
import Point from 'ol/geom/Point.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import {Icon, Style, Fill, Stroke, Text} from 'ol/style.js';

import {Tile as TileLayer} from 'ol/layer.js';
import {Circle as CircleStyle} from 'ol/style.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import {Cluster, Vector as VectorSource} from 'ol/source.js';

let map = new Map({
  layers: [
    new TileLayer({source: new OSM()})
  ],
  target: document.getElementById('map'),
  view: new View({
    projection: 'EPSG:4326',
    center: [12.479234, 41.894968],
    zoom: 6
  })
});

let phds = [
  {
    university: 'Politecnico di Milano',
    website: 'https://www.mate.polimi.it/dottorato/',
    lat: 45.479574, 
    lon: 9.229046,
    courseName: 'Mathematical Models and Methods in Engineering',
    logo: 'img/polimi.png'
  },
  {
    university: 'Politecnico di Torino',
    website: 'http://dottorato.polito.it/gpd/en/overview',
    lat: 45.062545,
    lon: 7.662327,
    courseName: 'Management, Production and Design',
    logo: 'img/polito.png'
  },
  {
    university: 'Università del Salento',
    website: 'https://www.matfis.unisalento.it/52',
    lat: 40.349556,
    lon: 18.167398 ,
    courseName: 'Matematica',
    logo: 'img/unisalento.jpg'
  },
  {
    university: 'Università di Bologna',
    website: 'https://www.unibo.it/en/teaching/phd/2019-2020/biomedical-electrical-and-system-engineering',
    lat: 44.487985,
    lon: 11.329260,
    courseName: 'Biomedical, Electrical, and Systems Engineering',
    logo: 'img/unibo.jpg'
  },
  {
    university: 'Università di Brescia',
    website: 'http://drii.unibs.it/',
    lat: 45.564549,
    lon: 10.231706,
    courseName: 'Ingegneria dell\'Informazione',
    logo: 'img/unibs.png'
  },
  {
    university: 'Università di Brescia',
    website: 'https://aem.unibs.it/',
    lat: 45.544043,
    lon: 10.219725,
    courseName: 'Analytics for Economics and Management',
    logo: 'img/unibs.png'
  },
  {
    university: 'Università di Firenze',
    website: 'https://www.unifi.it/p11549.html',
    lat: 43.798489,
    lon: 11.253010,
    courseName: 'Ingegneria dell\'Informazione',
    logo: 'img/unifi.png'
  },
  {
    university: 'Università di Milano',
    website: 'https://sites.unimi.it/dottoratomat/',
    lat: 45.473804,
    lon: 9.227541,
    courseName: 'Scienze Matematiche',
    logo: 'img/unimi.png'
  },
  {
    university: 'Università di Milano Bicocca',
    website: 'https://www.unimib.it/didattica/dottorato-ricerca/corsi-dottorato/informatica',
    lat: 45.523662,
    lon: 9.219544,
    courseName: 'Informatica',
    logo: 'img/unimib.png'
  },
  {
    university: 'Università di Modena e Reggio Emilia',
    website: 'https://www.unimore.it/didattica/dottorato.html?ID=1057',
    lat: 44.687537,
    lon: 10.667444,
    courseName: 'Ingegneria dell\'Innovazione Industriale',
    logo: 'img/unimore.jpg'
  },
  {
    university: 'Università di Napoli Federico II',
    website: 'http://dottorato-itee.dieti.unina.it/index.php/it/',
    lat: 40.845500,
    lon: 14.257774,
    courseName: 'Information Technology and Electrical Engineering',
    logo: 'img/unina.png'
  },
  {
    university: 'Università di Napoli Federico II',
    website: 'http://icth.dieti.unina.it/index.php/it/',
    lat: 40.845500,
    lon: 14.257774,
    courseName: 'Information and Commnication Technology for Health',
    logo: 'img/unina.png'
  },
  {
    university: 'Università di Pisa',
    website: 'https://www.di.unipi.it/en/phd',
    lat: 43.720649,
    lon: 10.408410,
    courseName: 'Informatica',
    logo: 'img/unipi.jpg'
  },
  {
    university: 'Università di Roma La Sapienza',
    website: 'http://www.dis.uniroma1.it/~abro/en',
    lat: 41.901399,
    lon: 12.512292,
    courseName: 'Automatica, Bioingegneria e Ricerca Operativa',
    logo: 'img/uniroma1.png'
  },
  {
    university: 'Università di Trento',
    website: 'https://www.unitn.it/drmath/4/doctoral-programme-mathematics-agreement-university-verona',
    lat: 46.066757,
    lon: 11.123047,
    courseName: 'Mathematical Modelling and Scientific Computing',
    logo: 'img/unitn.png'
  },
  {
    university: 'Università di Torino',
    website: 'https://en.unito.it/postdegree/phd/computer-science',
    lat: 45.069106,
    lon: 7.687888,
    courseName: 'Computer Science',
    logo: 'img/unito.png'
  },
  {
    university: 'Università di Udine',
    website: 'http://web.uniud.it/international-area/students-enrolling/dottorato/dottorati-sede-udine/Matematica%20e%20Fisica?lingua=ita',
    lat: 46.080556,
    lon: 13.211439,
    courseName: 'Matematica e Fisica',
    logo: 'img/uniud.png'
  },
  {
    university: 'Università Politecnica delle Marche',
    website: 'https://www.ingegneria.univpm.it/content/curricola-corso-di-dottorato-ingegneria-dellinformazione',
    lat: 43.586833,
    lon: 13.516584,
    courseName: 'Ingegneria dell\'Informazione',
    logo: 'img/univpm.png'
  },
  {
    university: 'Università dell\'Aquila',
    website: 'https://phdict.disim.univaq.it/',
    lat: 42.368411,
    lon: 13.350060,
    courseName: 'Information and Communication Technology',
    logo: 'img/univaq.png'
  },
  {
    university: 'Università della Calabria',
    website: 'http://dottorato.dimes.unical.it/',
    lat: 39.359996,
    lon: 16.226318,
    courseName: 'Information and Communication Technology',
    logo: 'img/unical.png'
  },
  {
    university: 'Università della Calabria',
    website: 'https://www.unical.it/portale/didattica/phdsea/presentazione/',
    lat: 39.359996,
    lon: 16.226318,
    courseName: 'Scienze Economiche e Aziendali',
    logo: 'img/unical.png'
  },
  {
    university: 'Università di Padova',
    website: 'https://dottorato.math.unipd.it/',
    lat: 45.410959,
    lon: 11.887625,
    courseName: 'Scienze Matematiche',
    logo: 'img/unipd.png'
  },
  {
    university: 'Università di Venezia',
    website: 'https://www.unive.it/pag/7867/',
    lat: 45.446461,
    lon: 12.318657,
    courseName: 'Management',
    logo: 'img/unive.gif'
  }
];

phds.sort((a,b) => (a.university > b.university) ? 1 : ((b.university > a.university) ? -1 : 0)); 

let markers = [];
let addedPhds = [];

for(let phd of phds) {
  let marker = new Feature({
    geometry: new Point([phd.lon, phd.lat]),
    text: '<a href="' + phd.website + '">' + phd.university + '</a><br>' + phd.courseName
  });

  marker.setStyle(new Style({
    image: new Icon(({
      crossOrigin: 'anonymous',
      src: 'img/marker.png',
      scale: 0.15,
      anchor: [0.5, 256],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
    }))
  }));

  markers.push(marker);

  let compactUniName = phd.university
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, "")
                        .replace(/\s/g, '')
                        .toLowerCase();

  if(!addedPhds.includes(phd.university)) {
    let phdCard =
      '<li id="card-' + compactUniName + '" class="list-group-item p-3">' +
        '<div class="row no-gutters">' +
          '<div class="col-md-1 text-center pr-3">' +
            '<img src="' + phd.logo + '" style="width: 100%; max-width: 200px;">' +
          '</div>' +
          '<div class="col pl-3">' +
            '<h3>' + phd.university + '</h3>' + 
            '<br><emph style="font-size: 150%;"><a href="' + phd.website + '">' + phd.courseName + '</a></emph>' +
          '</div>' +
        '</div>' +
      '</li>';

    let cardsContainer = document.getElementById('phd-cards-list');
    cardsContainer.insertAdjacentHTML('beforeend', phdCard);

    addedPhds.push(phd.university);
  } else {
    let courseNameText = $('#card-' + compactUniName + ' div div emph');

    if(courseNameText.length != 1) {
      console.error('Expecting exactly one text element, found ' + courseNameText.length);
    }

    courseNameText.append(', <a href="' + phd.website + '">' + phd.courseName + '</a>');
  }
}

let vectorSource = new VectorSource({
  features: markers
});

let markerVectorLayer = new VectorLayer({
  source: vectorSource
});

map.addLayer(markerVectorLayer);

let popup = document.getElementById('popup');
let popupOver = new Overlay({
  element: popup,
  positioning: 'top-center',
  stopEvent: false,
  offset: [0, -25]
});

map.addOverlay(popupOver);

map.on('click', function(e) {
  let ftr = map.forEachFeatureAtPixel(e.pixel, function(f) { return f; });

  if(ftr) {
    let coords = ftr.getGeometry().getCoordinates();

    $(popup).popover('dispose');

    popupOver.setPosition(coords);

    $(popup).popover({
      placement: 'top',
      html: true,
      content: ftr.get('text')
    });

    $(popup).popover('show');
  } else {
    $(popup).popover('dispose');
  }
});

map.on('pointermove', function(e) {
  if (e.dragging) {
    $(popup).popover('dispose');
    return;
  }

  let pixel = map.getEventPixel(e.originalEvent);
  let hit = map.hasFeatureAtPixel(pixel);

  map.getTarget().style.cursor = hit ? 'pointer' : '';
});